import { render } from "./extra_buttons.vue?vue&type=template&id=6fcf5bb3"
import script from "./extra_buttons.js?vue&type=script&lang=js"
export * from "./extra_buttons.js?vue&type=script&lang=js"

import "./extra_buttons.vue?vue&type=style&index=0&id=6fcf5bb3&lang=scss"

import exportComponent from "/builds/pleroma/pleroma-fe/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__